import request from '@/utils/request'
import requestStream from '@/utils/requestStream'

// 处理查询条件，删除多余空条件
function queryParamFactory(queryData){
  var queryParam = []
  if(queryData !== undefined){
    for (var key in queryData) {
      if(queryData[key].controlDefaultvalue != '' || queryData[key].controlLiketype == '!N' || queryData[key].controlLiketype == 'NN'){
        queryParam.push(JSON.parse(JSON.stringify(queryData[key])))
        if(queryParam[queryParam.length-1].controlType == 'SelectType' || queryParam[queryParam.length-1].controlType == 'Select'){
          queryParam[queryParam.length-1].controlDefaultvalue = queryParam[queryParam.length-1].controlDefaultvalue.join()
        }
      }      
    }
  }
  return queryParam
}

// 通用查询统计方法，所有统计查询只要是数据通过<jr-bigtable></jr-bigtable>组件展示的都通过此方法来查询
export function query(queryParam) {
  return request({
    url: '/api' + queryParam.queryPath,
    method: 'post',
    data: {
      querySortType: 'Server',
      querySumType: 'Server',
      queryLimit: queryParam.queryLimit,
      queryData: queryParamFactory(queryParam.queryData)
    }
  })
}

// 通用导出Excel方法，只要是数据通过<jr-bigtable></jr-bigtable>组件导出Excel都调用此方法
export function queryExport(queryParam, exportType, tableId) {
  if(exportType){
    queryParam.queryLimit.limit = 999999
  }
  return requestStream({
    url: '/api' + queryParam.queryPath + 'excel',
    method: 'post',
    data: {
      querySortType: 'Server',
      querySumType: 'Server',
      queryLimit: queryParam.queryLimit,
      queryData: queryParamFactory(queryParam.queryData),
      tableId: tableId
    },
    responseType: 'blob'
  })
}

// 通用导出Excel方法，只要是数据通过<jr-bigitemtable></jr-bigitemtable>组件导出Excel都调用此方法
export function queryItemExport(queryParam, primaryId, tableId) {

  return requestStream({
    url: '/api' + queryParam.queryPath + 'excel',
    method: 'post',
    params: {
      primaryId: primaryId,
      tableId: tableId
    },
    responseType: 'blob'
  })
}

// <jr-bigtable></jr-bigtable>组件配置参数恢复默认值
export function rollBackTableSetting(tableId) {
  return request({
    url: '/api/home/sys/pagetable/rollbacktablesetting',
    method: 'get',
    params: {
      tableId: tableId
    }
  })
}

// <jr-bigtable></jr-bigtable>保存组件配置参数
export function saveTableSetting(components) {
  return request({
    url: '/api/home/sys/pagetable/savetablesetting',
    method: 'post',
    data: components
  })
}






// WEBPACK FOOTER //
// ./src/api/public.js